import React from 'react';
import { menuItems } from '../../../common/menu';
import { NavMenuItem } from './NavMenuItem';

export const NavMenu = () => {
	return (
		<nav className="flex h-full" aria-label="Primary navigation">
			<ul className="flex justify-between w-full pl-8">
				{menuItems
				.filter(item => item.mainNav)
				.map((item, i) => (
					<li
						key={i}
						className={
							`w-full text-center
							${item.to === '/contact' ? 'primary hoverable borderless' : ''}`
						}
					>
						<NavMenuItem
							to={item.to || '/'}
						>
							<span className="relative block">
								{ item.label }
							</span>
						</NavMenuItem>
					</li>
				))}
			</ul>
		</nav>
	);
};
